/**
 * Tâche 1304 (Eric 2026-06-30) — Chercher un fichier par son IDENTIFIANT.
 *
 * Réservé aux personnes autorisées à concevoir ou corriger une formation
 * (`canEditContent`) : un identifiant technique n'a aucun sens pour un
 * apprenant, et ne doit pas servir à atteindre un fichier autrement filtré.
 *
 * Deux façons de récupérer un identifiant en pratique : le copier depuis la
 * fiche du fichier, ou le lire dans l'URL de la page. Les deux sont donc
 * acceptées, ainsi qu'un simple FRAGMENT (les 8 premiers caractères
 * suffisent pour distinguer une vidéo parmi des centaines).
 */

const UUID_RE = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i;

// Un identifiant ne contient ni espace ni ponctuation : 4 caractères au
// minimum pour ne pas transformer chaque mot tapé en recherche d'identifiant.
const FRAGMENT_RE = /^[0-9a-zA-Z_-]{4,}$/;

/**
 * Rend le fragment d'identifiant contenu dans la saisie, ou `null` quand la
 * saisie n'a rien qui ressemble à un identifiant (une phrase, par exemple).
 */
export function extractIdQuery(raw) {
  const txt = String(raw || "").trim();
  if (!txt) return null;
  // Identifiant complet, y compris collé au milieu d'une URL.
  const uuid = txt.match(UUID_RE);
  if (uuid) return uuid[0].toLowerCase();
  // URL collée dont l'identifiant n'est pas un UUID (fichiers légataires) :
  // on retient le dernier segment du chemin.
  let candidate = txt;
  if (txt.includes("://") || txt.startsWith("/")) {
    const segs = txt.split(/[/?#]/).filter(Boolean);
    candidate = segs.length ? segs[segs.length - 1] : "";
  }
  if (!candidate || /\s/.test(candidate)) return null;
  return FRAGMENT_RE.test(candidate) ? candidate.toLowerCase() : null;
}

/** Vrai si `id` contient le fragment d'identifiant saisi. */
export function matchesId(id, raw) {
  const q = extractIdQuery(raw);
  if (!q || !id) return false;
  return String(id).toLowerCase().includes(q);
}
